export default __webpack_public_path__ + "15001473cb35b1365f8bab8fdf0649fa.svg";